<template>
  <div class="mo_cart">
    <mbHeader :left="true" :title="$t('cart')" :color="false" :lang="true"></mbHeader>
    <div class="mid"></div>
    <div class="bot" v-if="loggedIn">
      <div class="feeShipping">
        <div class="fee-shipping-top">
          <div class="address" v-if="isDelivery">
            <div class="img"></div>
            <span>{{ $t('delivery_to') }}</span>
            <span class="userzip">{{ userZip }}</span>
          </div>
          <div class="address" v-if="isPickup">
            <div class="img"></div>
            <span>{{ $t('pick_up_from') }}</span>
            <span class="userzip">{{ this.warehouseLocation }}</span>
          </div>
          <div class="fee-shipping-top-right">
            {{ $t('subtotal') }} ${{ this.calculateLocalSubtotal() }}
          </div>
        </div>
        <div class="fee-shipping-bottom" v-if="(isDelivery && 39 - this.calculateLocalSubtotal() > 0) || (this.calculateLocalNotDiscountSubtotal() - this.calculateLocalSubtotal() > 0)">
          <img src="../../assets/img/icon-free-shipping.png" alt="">
          <div class="free" v-if="isDelivery && 39 - this.calculateLocalSubtotal() > 0">{{ $t('spend') }} ${{ (39 - this.calculateLocalSubtotal()).toFixed(2) }} {{ $t('more_to_get_free_shipping') }}</div>
          <div class="free" v-else-if="this.calculateLocalNotDiscountSubtotal() - this.calculateLocalSubtotal() > 0"> {{ $t('congratulation_you_saved') }} ${{ (this.calculateLocalNotDiscountSubtotal() - this.calculateLocalSubtotal()).toFixed(2) }}!</div>
        </div>
      </div>
      <ul class="cartList" v-if="cartProductsList.Sales_Order_Lines && cartProductsList.Sales_Order_Lines.length">
        <li v-for="(item,index) in cartProductsList.Sales_Order_Lines" :key="'cartProductsList.Sales_Order_Lines_'+index">
          <div class="left">
            <img
              v-lazy="item.Thumbnail"
              :key="item.Thumbnail"
              class="cart-image"
              :src="item.Thumbnail"/>
          </div>
          <div class="min">
            <div class="name">{{ curIsEnglish ? item.Name : item.Description }}</div>
            <div class="delete" @click="deleteItem(item)">{{ $t('delete') }}</div>
          </div>
          <div class="right">
            <div class="right-price-container">
              <div class="price-original" v-if="item.OriginalPrice && item.OriginalPrice !== item.Price">
                ${{ item.OriginalPrice }}
              </div>
              <div class="price" :style="(item.OriginalPrice && item.OriginalPrice !== item.Price) ? 'color: #fa6400;' : ''">${{ item.Price }}</div>
            </div>
            <div class="quantity-box">
              <button :class="item.quantity === 1 ? 'quantity-button-one' : 'quantity-button'" @click="updateItemCount($event, item)">-</button>
              <p class="curr-quantity">{{ item.Quantity }}</p>
              <button class="quantity-button" @click="throttleAddToCart(item)">+</button>
            </div>
          </div>
        </li>
      </ul>
      <div class="noCart" v-else>{{ $t('your_cart_empty') }}</div>
      <div class="checkBox">
        <div :class="disableCheckoutButton() ? 'checkout-disabled' : 'checkOut' "
             @click="postCartItemsAndCheckout($event)">{{ $t('continue_to_checkout') }} <i></i>
          ${{ this.calculateLocalSubtotal() }}
        </div>
        <div class="checkout-blurb-container">
          <p class="checkout-blurb">{{ $t('same_day_delivery') }}</p>
          <p class="checkout-blurb">{{ $t('out_of_stock_tip') }}</p>
        </div>
      </div>
    </div>
    <div class="bot" v-else>
      <div class="feeShipping">
        <div class="fee-shipping-top">
          <div class="address" v-if="isDelivery">
            <div class="img"></div>
            <span>{{ $t('delivery_to') }}</span>
            <span class="userzip">{{ userZip }}</span>

          </div>
          <div class="address" v-if="isPickup">
            <div class="img"></div>
            <span>{{ $t('pick_up_from') }}</span>
            <span class="userzip">{{ this.warehouseLocation }}</span>
          </div>
          <div class="fee-shipping-top-right">
            {{ $t('subtotal') }} ${{ this.calculateLocalSubtotal() }}
          </div>
        </div>
        <div class="fee-shipping-bottom" v-if="(isDelivery && 39 - this.calculateLocalSubtotal() > 0) || (this.calculateLocalNotDiscountSubtotal() - this.calculateLocalSubtotal() > 0)">
          <img src="../../assets/img/icon-free-shipping.png" alt="">
          <div class="free" v-if="isDelivery && 39 - this.calculateLocalSubtotal() > 0">{{ $t('spend') }} ${{ (39 - this.calculateLocalSubtotal()).toFixed(2) }} {{ $t('more_to_get_free_shipping') }}</div>
          <div class="free" v-else-if="this.calculateLocalNotDiscountSubtotal() - this.calculateLocalSubtotal() > 0"> {{ $t('congratulation_you_saved') }} ${{ (this.calculateLocalNotDiscountSubtotal() - this.calculateLocalSubtotal()).toFixed(2) }}!</div>
        </div>
      </div>
      <ul class="cartList" v-if="cartProductsList.length">
        <li v-for="(item,index) in cartProductsList" :key="'cartProductsList_'+index">
          <div class="left">
            <img
              v-lazy="item.Thumbnail"
              :key="item.Thumbnail"
              class="cart-image"
              :src="item.Thumbnail"/>
          </div>
          <div class="min">
            <div class="name">{{ curIsEnglish ? item.Name : item.Description }}</div>
            <div class="delete" @click="deleteItem(item)">{{ $t('delete') }}</div>
          </div>
          <div class="right">
            <div class="right-price-container">
              <div class="price-original" v-if="item.OriginalPrice && item.OriginalPrice !== item.Price">
                ${{ item.OriginalPrice }}
              </div>
              <div class="price" :style="(item.OriginalPrice && item.OriginalPrice !== item.Price) ? 'color: #fa6400;' : ''">${{ item.Price }}</div>
            </div>
            <div class="quantity-box">
              <button :class="item.quantity === 1 ? 'quantity-button-one' : 'quantity-button'" @click="updateItemCount($event, item)">-</button>
              <p class="curr-quantity">{{ item.quantity }}</p>
              <button class="quantity-button" @click="throttleAddToCart(item)">+</button>
            </div>
          </div>
        </li>
      </ul>
      <div class="noCart" v-else>{{ $t('your_cart_empty') }}</div>
      <button class="checkOut" @click="goToCart($event)">{{ $t('continue_to_checkout') }} <i></i>
        ${{ this.calculateLocalSubtotal() }}
      </button>
    </div>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import {mapActions, mapMutations, mapState} from "vuex";
import {
  isUserAuthenticated, setLocalCart,
} from "../../store/modules/cart";
import {locales} from "../../mixin";

export default {
  name: "mobileCart2",
  mixins: [locales],
  components: {mbHeader},
  methods: {
    ...mapMutations('navbar', ['toggleZipcodeModalVisibility','toggleLoginModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    ...mapActions('cart', ['getCart', 'addProductToLocalCart', 'deleteCartItem', 'updateItemQuantity', 'addCart', 'saveAndAdjustCart', 'addProductToCart']),
    calculateLocalSubtotal() {
      if (!this.loggedIn) {
        let cost = 0;
        this.$store.state.cart.cartProductsList.map(item => {
          let itemPrice = item.Price * item.quantity;
          cost += itemPrice;
        })
        return cost.toFixed(2);
      } else {
        return (this.$store.state.cart.cartProductsList.TotalPrice - this.Savings).toFixed(2);
      }
    },
    calculateLocalNotDiscountSubtotal() {
      let cost = 0;
      const arr = []
      let quantityKey = 'quantity'
      if (!this.loggedIn) {
        arr.push(...this.$store.state.cart.cartProductsList)
      } else {
        quantityKey = 'Quantity'
        arr.push(...this.$store.state.cart.cartProductsList.Sales_Order_Lines)
      }
      arr.map(item => {
        let itemPrice = item.Price * item[quantityKey];
        if (item.OriginalPrice && item.OriginalPrice !== item.Price) {
          itemPrice = item.OriginalPrice * item[quantityKey]
        }
        cost += itemPrice;
      })
      return cost.toFixed(2);
    },
    disableCheckoutButton() {
      if (isUserAuthenticated()) {
        if (this.cartProductsList.Sales_Order_Lines && !this.cartProductsList.Sales_Order_Lines.length) {
          return true;
        }
      } else {
        if (!this.cartProductsList.length) {
          return true
        }
      }
      return false;
    },
    postCartItemsAndCheckout(e) {
      e.preventDefault();
      if (!localStorage.getItem('warehouseLocationWeb')) {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (isUserAuthenticated()) {
        if (this.$store.state.cart.cartProductsList && this.$store.state.cart.cartProductsList.Sales_Order_Lines.length > 0) {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
            .then(() => {
              this.$router.push('/purchase');
            });
        }
      } else {
        this.toggleLoginModalVisibility(true);
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
            .then(() => {
              this.$store.dispatch('cart/getCart');
            });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount]);
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
    updateItemCount(e, item) {
      e.preventDefault();
      if (isUserAuthenticated()) {
        let quantity = item.Quantity - 1;
        if (quantity < 1) {
          this.deleteItem(item);
        } else {
          this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
            .then(() => {
              this.local = false;
              this.$store.dispatch('cart/getCart');
            });
        }
      } else {
        item.quantity = item.quantity - 1;
        if (item.quantity < 1) {
          this.deleteItem(item)
        }
        this.$store.dispatch('cart/updateLocalCart', item)
          .then(() => {
            this.local = true;
            this.$store.dispatch('cart/fetchCartProducts');
          })
      }
    },
    throttleAddToCart:  _.debounce(function(item, event) {
      this.addToCart(item)
    }, 150, {'leading': true, 'trailing': true}),

    addToCart: function(item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
        this.toggleZipcodeModalVisibility(true);
        return;
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
        });
    },
    handleAddToCartFail(product) {
      this.stopAddToCartLoading();
      alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
    },
    goToCart(e) {
      e.preventDefault();
      if (isUserAuthenticated()) {
        this.$router.push('/purchase')
      } else {
        this.toggleLoginModalVisibility(true);
      }
    },
  },
  computed: {
    ...mapState({
      shippingMethodGlobal: state => state.navbar.shippingMethodGlobal,
      userZip: state => state.navbar.userZip,
      warehouseLocation: state => state.navbar.warehouseLocation,
      cartProductsList: state => state.cart.cartProductsList,
      Savings: state => state.checkout.Savings,
      loggedIn: state => state.auth.loggedIn,
      allGroups: state => state.navbar.allGroups,
    }),
    // 是否是配送
    isDelivery() {
      return this.shippingMethodGlobal === 'Delivery'
    },
    // 是否是取货
    isPickup() {
      return this.shippingMethodGlobal === 'Pickup'
    }
  },
  activated() {
    localStorage.removeItem('beforeRefreshPromoCode')
    localStorage.removeItem('promo-code')
  }
}
</script>

<style scoped lang="less">
.mo_cart {
  display: none;
}

@media only screen and (max-width: 768px) {
  .mo_cart {
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    padding-top: 50px;

    .top {
      flex: 1;
      padding: 66px 16px 0;
      overflow: hidden;
      .allGroups {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        &:after {
          content: "";
          visibility: hidden;
          width: calc(33.3% - 8px);
        }

        li {
          width: calc(33.3% - 5px);
          display: flex;
          flex-flow: column;
          align-items: center;
          margin-bottom: 16px;
          .groupImg {
            width: 90px;
            height: 90px;
            display: flex;
            align-items: center;
            border-radius: 5px;
            box-shadow: 1px 3px 4px 2px rgba(0, 0, 0, 0.05);
            margin-bottom: 10px;
            img {
              width: 100%;
              max-height: 100%;
            }
          }

          span{
            font-size: 10px;
            display: block;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
          }

        }
      }
    }

    //.mid {
    //  height: 50px;
    //  background-color: #000000;
    //}

    .bot {
      width: 100%;
      height: 100%;
      padding: 10px 16px 76px;
      background-color: rgba(0,0,0,0.03);
      color: #FFFFFF;
      font-size: 10px;
      display: flex;
      flex-flow: column;
      position: relative;

      .feeShipping{
        display: flex;
        flex-direction: column;
        padding: 10px 0;

        .fee-shipping-top {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .address{
            display: flex;
            align-items: center;
            color: #131e1e;
            font-weight: 600;
            font-family: 'Source Sans Pro';

            img{
              height: 15px;
              width: auto;
              margin-right: 5px;
            }

            .img{
              height: 15px;
              width: 15px;
              background-color: black;
              -webkit-mask: url("../../assets/img/pin2.png") no-repeat center;
              mask: url("../../assets/img/pin2.png") no-repeat center;
              mask-size: 15px 15px;
              margin-right: 5px;
            }
            .userzip{
              margin-left: 5px;
            }
          }

          .fee-shipping-top-right {
            color: #131e1e;
            font-weight: 600;
            font-family: 'Source Sans Pro';
          }
        }

        .fee-shipping-bottom {
          width: 100%;
          height: 30px;
          margin: 20px auto 5px;
          background-image: url("../../assets/img/rectangle-notification-bg.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          padding-left: 19px;

          > img {
            width: 21px;
            height: auto;
            margin-right: 16px;
          }

          .free {
            font-family: 'Source Sans Pro';
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: 0.1px;
            color: #7cc26a;
          }
        }
      }



      .noCart {
        flex: 1;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #b6b6b6;
      }

      .cartList {
        flex: 1;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        li {
          display: flex;
          align-items: center;
          padding: 10px 0;
          border-bottom: 1px solid #E7EBEA;
          height: 95px;

          > div {
            height: 100%;
          }

          //&:first-child {
          //  border-top: 1px solid #2a3534;
          //}

          &:last-child {
            border-bottom: 0;
          }

          .left {
            width: 75px;
            height: 75px;
            display: flex;
            align-items: center;
            margin-right: 10px;
            flex-shrink: 0;

            img {
              width: 100%;
              max-height: 100%;
            }
          }

          .min {
            flex: 1;
            font-family: 'Source Sans Pro';
            font-weight: 600;
            color: #131e1e;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .delete {
              display: inline;
              color: #8ba39e;
            }
          }

          .right {
            width: 80px;
            margin-left: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-end;

            .right-price-container {
              font-family: 'Source Sans Pro';
              font-weight: 600;
              color: #131e1e;
              display: flex;
              flex-direction: row-reverse;
              font-size: 9px;

              .price {
                margin: 3px 0;
              }

              .price-original {
                margin: 3px 0 3px 5px;
                text-decoration: line-through;
              }
            }



            .quantity-box {
              width: 100%;
              height: 24px;
              display: flex;
              flex-direction: row;
              justify-content: space-evenly;
              align-items: center;
              border-radius: 15px;
              border: 1px solid #9CA1A1;
              font-family: Arial;

              .quantity-button,.quantity-button-one{
                font-size: 16px;
                padding: 0 5px;
                border: none;
                outline: none;
                color: #9CA1A1;
                background-color: transparent;
                font-family: Arial;
              }

              //.quantity-button-one{
              //  color: #999999;
              //}

              .curr-quantity {
                color: #9CA1A1;
                font-size: 12px;
              }
            }
          }
        }
      }

      .checkBox{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        //background-color: rgba(0,0,0,.8);
        padding:  10px 0;
        display: flex;
        flex-flow: column;
      }

      .checkOut, .checkout-disabled {
        min-width: 60%;
        padding: 0 20px;
        height: 35px;
        font-size: 15px;
        font-weight: bold;
        font-family: Arial;
        background-color: #7cc26a;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 10px;
        border: none;
        color: #FFFFFF;

        i {
          width: 2px;
          height: 15px;
          background-color: #FFFFFF;
          margin: 0 10px 0;
        }
      }

      .checkout-disabled {
        background-color: #818181;
      }

      .checkout-blurb-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        max-width: 60%;
        margin: 0 auto;

        .checkout-blurb {
          text-align: center;
          color: #d8d8d8;
          padding: 0 8px;
        }
      }
    }
  }
}

</style>

<style lang="less">
main {
  .mo_cart + .tabbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileCart2.vue